var map = {
	"./locale-context/en_GB.tsx": "./components-pro/locale-context/en_GB.tsx",
	"./locale-context/en_US.tsx": "./components-pro/locale-context/en_US.tsx",
	"./locale-context/ja_JP.tsx": "./components-pro/locale-context/ja_JP.tsx",
	"./locale-context/zh_CN.tsx": "./components-pro/locale-context/zh_CN.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components-pro sync recursive ^\\.\\/locale-context\\/.+_.+\\.tsx$";